import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { AllIconsComponent } from "../all-icons/all-icons.component";
import { NgClass } from "@angular/common";

@Component({
  selector: 'app-drop-down-item',
  templateUrl: './drop-down-item.component.html',
  styleUrls: ['./drop-down-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AllIconsComponent,
    NgClass,
  ],
})
export class DropDownItemComponent {
  // e.x. 'upload-arrow-in-circle.svg; icon-size-1p5'
  @Input() iconNameAndStyling: string;
  @Input() disabled = false;
  @Input() text = '';
  @Input() menuItemClass = '';
  @Output() itemClick = new EventEmitter<void>();

  itemClickEmitter(): void {
    if (this.disabled) {
      return;
    }

    this.itemClick.emit();
  }
}

